export function Footer() {
	return (
		<footer className="landing-footer">
			<p className="landing-footer-copyright">
				&copy; {new Date().getFullYear()} PlaySmith. All rights reserved.
			</p>
		</footer>
	)
}
